import restAPI from "@/http-common";
import { categoryOverviewRequest } from "./CancellableRequest";
import AdApi from "./Api";
import session from "./session";

class CategoryApi {
	getCategoryOverview(isCompare = false) {
		categoryOverviewRequest.cancel(isCompare);

		return restAPI({
			method: "get",
			url: "group-overview?",
			params: AdApi.getQueryParams(isCompare),
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {},
			cancelToken: categoryOverviewRequest.generateCancelToken(isCompare)
		});
	}

	getCategories() {
		return restAPI({
			method: "get",
			url: "/groups",
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}
}

export const CategoryService = new CategoryApi();
